module.exports = __webpack_public_path__ + "img/guigeliao2.fd18f351.jpg";